import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { LoanRepaymentTemplate } from 'app/model/loanrepaymenttemplate';
import { LoanForeclosureTemplate } from 'app/model/loanrepaymenttemplate';
import { AccountSearchSummary } from 'app/model/accountsearchsummary';
import { Router, ActivatedRoute } from '@angular/router';
import { LoanTransactionsService } from '../loan-transactions.service';
import { SelectedCurrencyOptions } from 'app/model/currencyoptions';
import { ReceiptServiceService } from 'app/shared/receipt-dialog/receipt-service.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogHelper } from 'app/core/utils/dialog-helper';
import { SettingsService } from 'app/settings/settings.service';
import { DatePipe } from '@angular/common';
import { TellerGlobalServiceService } from 'app/shared/teller-data/teller-global-service.service';
import { Subscription } from 'rxjs';
import { CheckDetails } from 'app/model/checkdetails';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'mifosx-loan-repayment',
  templateUrl: './loan-foreclosure.component.html',
  styleUrls: ['./loan-foreclosure.component.scss']
})
export class LoanForeclosureComponent implements OnInit {

  minDate = new Date(2000, 0, 1);
  maxDate = new Date();

  /** Loan Id */
  loanId: string;

  /** Payment Type Options */
  paymentTypes: any;

  foreclosureLoanForm: FormGroup;

  /** Show payment details */
  showPaymentDetails = false;

  obligationsMet = false;

  /** Show check details */
  showCheckDetailsView: Boolean = false;
  addCheckDetailsFlag: Boolean = false;

  /** Check Details */
  checkDetailsTable = new MatTableDataSource<CheckDetails>();
  checkDetails: Array<CheckDetails> = [];
  checkDetail: CheckDetails = {
    id: 0,
    checkAccountNumber: '',
    checkNumber: '',
    checkSecurityNumber: '',
    checkAmount: '',
    checkAmountToDeposit: '',
    targetName: '',
    countryCode: '',
    currencyCode: null,
    bankCode: '',
    locale: ''
  };
  checkForm: FormGroup;

  /** A summary of loan a ccount from search */
  loanAccountSummary: AccountSearchSummary;

  /** Template to populate loan repayment form */
  loanRepaymentTemplate: LoanRepaymentTemplate;

  /** Template to populate loan repayment form */
  loanForeclosureTemplate: LoanForeclosureTemplate;

  /** Flag to control if loan repayment view should be shown */
  showLoanForeclosureView: boolean = false;

  /** Flag to control if loan repayment view should be shown */
  showLoanRepaymentView: boolean = false;

  /** Flag to show loan summary view */
  showLoanSummaryView: boolean = false;

  /** Flag to indicate if the loan foreclosure was submitted to API*/
  loanForeclosureSubmitedToAPI: boolean = false;


  /**System supported currencies */
  currencyOptions: SelectedCurrencyOptions;
  selectedTeller: any;
  isDisabled: Boolean = false;
  nextRepaymentDate: string;
  transactionDate: string;
  foreclosureDate: string;
  expectedAmount: string;
  tellerSub: Subscription;
  loanCurrencyId: any;
  loanCurrencyCode: any;

  cancelationQuote: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private loanService: LoanTransactionsService,
    private receiptService: ReceiptServiceService,
    private matDialog: MatDialog,
    private dialogHelper: DialogHelper,
    private settingsService: SettingsService,
    private datePipe: DatePipe,
    private tellerGlobalService: TellerGlobalServiceService) { }

  ngOnInit(): void {
    this.createforeclosureLoanForm();
    this.createCheckForm();

    this.route.url.subscribe(urlSegments => {
      const segmentsArray = urlSegments.map(segment => segment.path);
      const startIndex = segmentsArray.indexOf('cotizaciones');
      
      if (startIndex !== -1 && startIndex < segmentsArray.length - 1) {
        const desiredSegment = segmentsArray.slice(startIndex + 1).join('/');
        console.log(desiredSegment);
        this.cancelationQuote = desiredSegment.includes('cancalecione');
      }
    });

    this.tellerSub = this.tellerGlobalService.getSelectedTeller$().subscribe(data => {
      this.selectedTeller = data;
    });

    this.route.data.subscribe(({ loanAcountData }) => {
      if(loanAcountData != null) {
        this.loanAccountSummary = loanAcountData.pop();
      }
    });

    this.route.data.subscribe(({ supportedCurrencies }) => {
      this.currencyOptions = supportedCurrencies;
    }) 
    
    this.route.params.subscribe(params => { 
      this.loanId = params['id'];
    })

    this.route.data.subscribe(({ loanRepaymentTemplateData }) => {
      this.setLoanRepaymentTemplate(loanRepaymentTemplateData);
    });

    this.route.data.subscribe(({ loanForeClosureData }) => {
      this.setLoanForeClosureTemplate(loanForeClosureData);
      this.showLoanSummaryView = true;
    });
  }

  ngOnDestroy() {
    this.tellerSub.unsubscribe();
  }

  /**
   * Creates the create close form.
   */
  createforeclosureLoanForm() {
    this.foreclosureLoanForm = this.formBuilder.group({
      'transactionDate': [new Date(), Validators.required],
      'principalPortion': '',
      'interestPortion': '',
      'feeChargesPortion': '',
      'penaltyChargesPortion': '',
      'amount': '',
      'note': '',
      'paymentTypeId': '',
      'currencyCode': ''
    });
  }

  createCheckForm() {
    this.checkForm = this.formBuilder.group({
    });
  }

  /**
   * Add payment detail fields to the UI.
   */
  addPaymentDetails() {
    this.showPaymentDetails = !this.showPaymentDetails;
    if (this.showPaymentDetails) {
      this.foreclosureLoanForm.addControl('accountNumber', new FormControl(''));
      this.foreclosureLoanForm.addControl('checkNumber', new FormControl(''));
      this.foreclosureLoanForm.addControl('routingCode', new FormControl(''));
      this.foreclosureLoanForm.addControl('receiptNumber', new FormControl(''));
      this.foreclosureLoanForm.addControl('bankNumber', new FormControl(''));
    } else {
      this.foreclosureLoanForm.removeControl('accountNumber');
      this.foreclosureLoanForm.removeControl('checkNumber');
      this.foreclosureLoanForm.removeControl('routingCode');
      this.foreclosureLoanForm.removeControl('receiptNumber');
      this.foreclosureLoanForm.removeControl('bankNumber');
    }
  }

  /**
  * Method to add payment detail fields to the UI.
  */
  addCheckDetails() {
    this.addCheckDetailsFlag = !this.addCheckDetailsFlag;
    if (this.addCheckDetailsFlag) {
      this.checkForm.addControl('checkAccountNumber', new FormControl(''));
      this.checkForm.addControl('chequeNumber', new FormControl(''));
      this.checkForm.addControl('checkSecurityNumber', new FormControl(''));
      this.checkForm.addControl('checkAmount', new FormControl(this.loanForeclosureTemplate.amount));
      this.checkForm.addControl('checkAmountTo', new FormControl(''));
      this.checkForm.addControl('targetName', new FormControl(''));
      this.checkForm.addControl('chequeCountry', new FormControl(1270));
      this.checkForm.addControl('chequeCurrency', new FormControl( this.loanCurrencyCode));
      this.checkForm.addControl('chequeBank', new FormControl(''));
    } else {
      this.checkForm.removeControl('checkAccountNumber');
      this.checkForm.removeControl('chequeNumber');
      this.checkForm.removeControl('checkSecurityNumber');
      this.checkForm.removeControl('checkAmount');
      this.checkForm.removeControl('checkAmountTo');
      this.checkForm.removeControl('targetName');
      this.checkForm.removeControl('chequeCountry');
      this.checkForm.removeControl('chequeCurrency');
      this.checkForm.removeControl('chequeBank');
    }
  }

  checkForEnableCheckOption(value: any) {
    console.log("value: " + value);

    // Disable or enable the "submit" button
    if(value === 1) {
      this.isDisabled = false;  
      this.showCheckDetailsView = false;
    } else {
      this.isDisabled = (this.checkDetails.length == 0 ? true : false);
      this.showCheckDetailsView = (value === 2 || value === 3);      
    }
  }

  clearCheckFields() {
    this.checkForm.get('checkAccountNumber').setValue('');
    this.checkForm.get('chequeNumber').setValue('')
    this.checkForm.get('checkSecurityNumber').setValue('');
    this.checkForm.get('checkAmount').setValue('');
    this.checkForm.get('checkAmountTo').setValue('');
    this.checkForm.get('targetName').setValue('');
    this.checkForm.get('chequeCountry').setValue(1270);
    this.checkForm.get('chequeCurrency').setValue(this.loanCurrencyCode);
    this.checkForm.get('chequeBank').setValue('');
  }

  addNewCheck() {

    let checkData = {} as CheckDetails;

    checkData.id = this.checkDetails.length;
    checkData.checkAccountNumber = this.checkForm.get('checkAccountNumber').value;
    checkData.checkNumber = this.checkForm.get('chequeNumber').value;
    checkData.checkSecurityNumber = this.checkForm.get('checkSecurityNumber').value;
    checkData.checkAmount = this.checkForm.get('checkAmount').value;
    checkData.checkAmountToDeposit = this.checkForm.get('checkAmount').value;
    checkData.targetName = this.checkForm.get('targetName').value;
    checkData.countryCode = this.checkForm.get('chequeCountry').value;
    checkData.bankCode = this.checkForm.get('chequeBank').value;
    checkData.currencyCode = this.loanCurrencyId;
    checkData.targetName = "Automatic";
    checkData.locale = this.settingsService.language.code;

    this.checkDetails.push(checkData);
    this.checkDetailsTable.data = this.checkDetails;
    this.clearCheckFields();

    this.isDisabled = false;  

  }

  removeCheck(id: number) {
    this.checkDetails.splice(id, 1);
    this.checkDetailsTable.data = this.checkDetails;

    // Disable "submit" button
    if(this.checkDetails.length === 0 && this.showCheckDetailsView) {
      this.isDisabled = true;  
    }
  }


  updateAccountDetail(event: Array<AccountSearchSummary>) {

    if (event.length > 0) {
      this.loanAccountSummary = event.pop();
      this.showLoanSummaryView = true;

      this.loanService.getLoanActionTemplate<LoanRepaymentTemplate>(<string><unknown>this.loanAccountSummary.entityId)
        .subscribe(res => {
          this.setLoanRepaymentTemplate(res);
          var zeroedAmount = res.amount === 0;

          if (zeroedAmount) {
            this.obligationsMet = true;
          } else {
            this.obligationsMet = false;
          }
          
        });


        // Call foreclosure without params...
        this.loanService.getLoanForeclosureActionTemplate<LoanForeclosureTemplate>(<string><unknown>this.loanAccountSummary.entityId)
        .subscribe(res => {
         
            this.setLoanForeClosureTemplate(res);
        });

    } else {
      this.showLoanRepaymentView = false;
    }
  }

  setLoanRepaymentTemplate(res: LoanRepaymentTemplate) {
    this.loanRepaymentTemplate = res;
    this.showLoanRepaymentView = true;

    if(this.loanRepaymentTemplate != null) {
      this.nextRepaymentDate = this.datePipe.transform(this.loanRepaymentTemplate.date, this.settingsService.dateFormat)
      this.expectedAmount = `${this.loanRepaymentTemplate.amount} (${this.loanRepaymentTemplate.currency.code})`;

      this.loanCurrencyCode = this.loanRepaymentTemplate.currency.code;
      this.loanCurrencyId = this.loanRepaymentTemplate.currency.intCode;
    }
  }

  setLoanForeClosureTemplate(res: LoanForeclosureTemplate) {
  
    this.loanForeclosureTemplate = res;
    this.showLoanForeclosureView = true;
    this.loanForeclosureTemplate.date = new Date();

    // Is paid / overpáid?
    if(res.amount == 0 && !this.cancelationQuote) {
      this.isDisabled = true;
    } else {
      this.isDisabled = false;
    }

    this.foreclosureDate = this.datePipe.transform(this.loanRepaymentTemplate.date, this.settingsService.dateFormat)
    this.nextRepaymentDate = this.datePipe.transform(this.loanRepaymentTemplate.date, this.settingsService.dateFormat)
    this.expectedAmount = `${this.loanRepaymentTemplate.amount} (${this.loanRepaymentTemplate.currency.code})`;

    this.transactionDate = this.datePipe.transform(this.loanForeclosureTemplate.date, this.settingsService.dateFormat);

    this.foreclosureLoanForm.get('paymentTypeId').markAsTouched();
    this.isDisabled = !this.cancelationQuote;
  }

  getFormattedDate(){
    return this.datePipe.transform(this.foreclosureLoanForm.get('transactionDate').value, this.settingsService.dateFormat);
  }

  applyFilter() {
    var foreclosureDateCopy = this.getFormattedDate(); //this.datePipe.transform(this.foreclosureLoanForm.get('transactionDate').value, "MM/dd/yyyy");
    if(!this.cancelationQuote){

      foreclosureDateCopy = this.datePipe.transform(this.foreclosureLoanForm.get('transactionDate').value, "MM/dd/yyyy");

      this.loanService.getLoanForeclosureForDateActionTemplate<LoanForeclosureTemplate>(<string><unknown>this.loanAccountSummary.entityId,
        <string><unknown>foreclosureDateCopy)
      .subscribe(res => {
        this.setLoanForeClosureTemplate(res);
        this.showLoanForeclosureView = true;
      });
    }else{
      this.loanService.getForeClosureQuotation(this.loanId,this.getFormattedDate())
      .subscribe((res) => {
        this.setLoanForeClosureTemplate(res.loanTransactionData);
        this.showLoanForeclosureView = true;
      });
    }
  }

  exportToExcel() {
    this.loanService.getPrintableForeClosureQuotation(this.loanId,this.getFormattedDate(),'excel')
    .subscribe((data: Blob) => {
      const downloadLink = window.URL.createObjectURL(data);
      const link = document.createElement('a');
      link.href = downloadLink;
      link.download = 'Loan_cancelacione'+this.loanId+'.xlsx';
      link.click();
    });
  }

  exportToPDF() {
    this.loanService.getPrintableForeClosureQuotation(this.loanId,this.getFormattedDate(),'pdf').subscribe(data =>
      this.dialogHelper.showDialogNoCloseAction(data, this.matDialog));
  }


  /** Submits the repayment form */
  submit() {
    this.isDisabled = true;

    const prevTransactionDate: Date = new Date();
    // TODO: Update once language and date settings are setup
    const dateFormat = this.settingsService.dateFormat;

    this.foreclosureLoanForm.patchValue({
      transactionDate: this.datePipe.transform(prevTransactionDate, 'MM/dd/yyyy')
    });

    this.foreclosureLoanForm.removeControl('amount');
    this.foreclosureLoanForm.removeControl('feeChargesPortion');
    this.foreclosureLoanForm.removeControl('interestPortion');
    this.foreclosureLoanForm.removeControl('penaltyChargesPortion');
    this.foreclosureLoanForm.removeControl('principalPortion');

    const repaymentLoanData = this.foreclosureLoanForm.value;
    repaymentLoanData.locale = 'es_GT';
    repaymentLoanData.dateFormat = 'MM/dd/yyyy';
    repaymentLoanData.currencyCode = this.loanCurrencyCode;


    if (this.checkDetails.length > 0) {
      repaymentLoanData['checksDetails'] = this.checkDetails;
    }

//    console.log("this.expectedAmount: " + this.expectedAmount);
    repaymentLoanData.transactionAmount = this.loanForeclosureTemplate.amount;
//    console.log("JSON Enviado")
//    console.log(repaymentLoanData)
    
    this.loanService.submitLoanActionButton(<string><unknown>this.loanAccountSummary.entityId, repaymentLoanData, 'foreclosure')
      .subscribe((res: any) => {
        this.showLoanSummaryView = false;

        this.loanForeclosureSubmitedToAPI = true;

        repaymentLoanData.transactionAmount = this.expectedAmount.toString().replace(".", ",").replace(" (GTQ)", "");
        repaymentLoanData.channel = 'caja';

        if(this.selectedTeller == null) {
          this.tellerSub = this.tellerGlobalService.getSelectedTeller$().subscribe(data => {
            this.selectedTeller = data;
          });
        }

        this.receiptService.getTellerReport(this.selectedTeller.id, 'Caja_loan_foreclosure', res.changes.transactions[0].toString()).subscribe(data =>
        this.dialogHelper.showDialog(data, this.matDialog, this.router, this.route));

      }, error => {
        console.log("Error Pago")
        console.log(error);
        this.isDisabled = false;
      },);

  }
}